// @flow

import { reducerWrapper } from '../support/utils';
import {
  GET_CONVERSION_VALUE_MAPPING,
  UPDATE_CONVERSION_VALUE_MAPPING,
  DELETE_CONVERSION_VALUE_MAPPING,
  UPDATE_SK_AD_NETWORK_ENABLED_EDIT,
  SAVE_SK_AD_NETWORK_CONFIGURATION,
  CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES
} from '../actions/SKAdnetworkAction';

import type { SKAdnetworkReducer } from '../types/skadnetworkTypes';

const INIT_STATE: SKAdnetworkReducer = {
  conversionValueMapping: undefined,
  conversionValueMappingRevisions: [],
  skAdNetworkEnabledEdit: undefined
};

function Handler(state, action) {
  switch (action.type) {
    case GET_CONVERSION_VALUE_MAPPING.response:
      return {
        ...state,
        conversionValueMapping: action.data
      };

    case UPDATE_CONVERSION_VALUE_MAPPING:
    case DELETE_CONVERSION_VALUE_MAPPING:
      return {
        ...state,
        conversionValueMappingRevisions: [
          ...state.conversionValueMappingRevisions,
          action.data
        ]
      };

    case UPDATE_SK_AD_NETWORK_ENABLED_EDIT:
      return {
        ...state,
        skAdNetworkEnabledEdit: action.data
      };

    case SAVE_SK_AD_NETWORK_CONFIGURATION.response:
      return {
        ...INIT_STATE,
        conversionValueMapping: action.data.updatedConversionValueMapping
      };
    case CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES:
      return {
        ...state,
        conversionValueMappingRevisions: [],
        skAdNetworkEnabledEdit: undefined
      };
    default:
      return state;
  }
}

export default reducerWrapper(INIT_STATE, Handler, {
  request: [],
  error: [],
  resetOn: ['APP_CHANGE']
});
